import { isFunction } from 'client/javascript/util/utils';

export default class NumberStepper {
  constructor(element, opts = {}) {
    this.onChange = opts.onChange;
    this.element = element;
    if (element) {
      this.input = this.element.querySelector('input');
      this.setUpInputValidation();
      this.createNumberStepper();
    }
  }

  handleChange(value) {
    if (isFunction(this.onChange)) {
      this.onChange(value);
    }
  }

  createNumberStepper() {
    const increaseButton = this.element.querySelector('button.number-stepper-increase');
    const decreaseButton = this.element.querySelector('button.number-stepper-decrease');

    increaseButton.addEventListener('click', this.incrementEvent.bind(this, true, this.input), false);
    decreaseButton.addEventListener('click', this.incrementEvent.bind(this, false, this.input), false);
  }

  setUpInputValidation = () => this.input.addEventListener('keydown', this.validationNumberInput);

  validationNumberInput = (event) => {
    if (event.key.length > 1 || Number.isInteger(+event.key)) {
      return;
    }
    event.preventDefault();
  };

  incrementEvent(increase, input, event) {
    const value = Number(input.value);
    const min = Number(input.min || Number.NEGATIVE_INFINITY);
    const max = Number(input.max || Number.POSITIVE_INFINITY);

    event.preventDefault();

    const newValue = increase ? value + 1 : value - 1;

    if (newValue >= min && newValue <= max) {
      input.value = newValue; // eslint-disable-line no-param-reassign
    }

    this.handleChange(input.value);
  }
}
